import { UseQueryResult } from '@tanstack/react-query'
import { useMemo } from 'react'
import { useProductsQueries, UseProductsQueriesParams } from '../useProducts'
import { getVideoShowcasesFromDynamicContent, VIDEO_SHOWCASES_COMPONENT_NAME } from './utils'
import { useResellerContext } from '../useResellerContext'
import { useDynamicContentForHome } from '@grupoboticario/barril-del-chavo'

class UseVideoShowcaseError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'UseVideoShowcaseError'
  }
}

/**
 * Hook para obter as vitrines de foco dinâmicas da home, a partir do conteúdo dinâmico.
 */
export function useVideoShowcase() {
  const resellerContext = useResellerContext()
  const dynamicContentForHome = useDynamicContentForHome({
    resellerSlug: resellerContext!.reseller!.catalogSlug,
  })
  const { isLoading, isError, error } = dynamicContentForHome

  const videoList = useMemo(() => {
    if (isLoading || !dynamicContentForHome.data) {
      return []
    }

    try {
      return getVideoShowcasesFromDynamicContent(dynamicContentForHome.data)
    } catch (error) {
      window.NREUM.noticeError(new UseVideoShowcaseError('Failed to extract dynamic showcases'), {
        customAttributes: {
          component: VIDEO_SHOWCASES_COMPONENT_NAME,
          error: error instanceof Error ? error.message : String(error),
        },
        customError: true,
      })

      return []
    }
  }, [isLoading, dynamicContentForHome.data])

  return {
    videoList,
    isLoading,
    isError,
    error: error as UseQueryResult<unknown, Error>['error'],
  }
}
